import { render, staticRenderFns } from "./PagoTable.vue?vue&type=template&id=4d4f5b96"
import script from "./PagoTable.vue?vue&type=script&lang=js"
export * from "./PagoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports